/// <amd-module name="Widgets/WorkLinksWidget/WorkLinksWidget" />
import { WidgetProps } from "Dashboards/WidgetContracts/WidgetProps";
import * as React from "react";
import { VisualTitle } from "Reporting/Visuals/VisualTitle";
import * as TfsWidgetContext from "Tfs/Widget/Context";
import { FPSLink, IFPSLinkProps } from "VSS/Features/PlatformUI/FPSLink";
import { IVssComponentContext, VssComponent } from "VSS/Platform/Layout";
import { routeUrl } from "VSS/Platform/Location";
import * as Resources from "Widgets/WorkLinksWidget/Resources";

/**
 * Encapsulates a single link with title and url.
 */
export interface IWorkLink {
    title: string;
    url: string;
}

export class WorkLinksWidget extends VssComponent<WidgetProps> {
    public static componentType = "workLinksWidget";

    private projectName: string;
    private teamName: string;

    constructor(props: WidgetProps, context: IVssComponentContext) {
        super(props);

        this.projectName = TfsWidgetContext.getProject(context.pageContext).name;
        this.teamName = props.teamContext.name;
    }

    public componentDidMount(): void {
        this.props.onWidgetLoaded();
    }

    public render(): JSX.Element {
        return (
            <div className="work-links-widget">
                <VisualTitle suppressDefaultPadding text={Resources.Title} />
                {this.renderWorkLinks()}
            </div>
        );
    }

    public renderWorkLinks(): JSX.Element {
        let commonLinkProps: IFPSLinkProps = {};
        if (this.props.openLinksInNewTab) {
            commonLinkProps = {
                target: "_blank",
                rel: "noreferrer noopener nofollow",
                supportsFPS: false
            };
        }

        const listItems = this.getWorkLinks().map<JSX.Element>((link, index) => (
            <div className="work-link" key={index}>
                <FPSLink {...commonLinkProps} href={link.url}>
                    {link.title}
                </FPSLink>
            </div>
        ));
        return <>{listItems}</>;
    }

    private getWorkLinks(): IWorkLink[] {
        return [
            {
                // Backlog
                title: Resources.BacklogText,
                url: routeUrl(this.context.pageContext, "ms.vss-work-web.backlogs-content-route", { 
                    project: this.projectName, 
                    team: this.teamName,
                    teamName: this.teamName,
                    pivot: "backlog"
                })
            },
            {
                // Board
                title: Resources.BoardText,
                url: routeUrl(this.context.pageContext, "ms.vss-work-web.team-board-content-route", {
                    project: this.projectName,
                    team: this.teamName,
                    teamName: this.teamName,
                    pivot: "board"
                })
            },
            {
                // Task board
                title: Resources.TaskBoardText,
                url: routeUrl(this.context.pageContext, "ms.vss-work-web.sprints-content-route", {
                    project: this.projectName,
                    team: this.teamName,
                    teamName: this.teamName,
                    pivot: "taskboard"
                })
            },
            {
                // Queries
                title: Resources.QueriesText,
                url: routeUrl(this.context.pageContext, "ms.vss-work-web.query-search:route", { project: this.projectName, team: this.teamName })
            }
        ];
    }
}

VssComponent.register(WorkLinksWidget.componentType, WorkLinksWidget);
